import DomElementBuilder from "../../sxQuery/DomElementBuilder";
import UiColors from "../styles/UiColors";
import Icons from "./Icons";
class VariantsCarousel {
    constructor(suggest, variantImages, classPrefix, label, lazyLoadImages) {
        this.suggest = suggest;
        this.variantImages = variantImages;
        this.classPrefix = classPrefix;
        this.label = label;
        this.lazyLoadImages = lazyLoadImages;
    }
    render(activeIdentifier) {
        const { suggest, label, lazyLoadImages, classPrefix } = this;
        const variantUl = DomElementBuilder.createElement({
            tag: 'ul',
            classList: [`${classPrefix}__variants`, 'ss360-variants'],
            attrs: {
                'aria-label': label
            }
        });
        const createVariantWrap = (modifier, label) => {
            const icon = Icons.getSvgIconNode(Icons.SIMPLE_ARROW, UiColors.THEME, `${classPrefix}__variant-arrow-icon ss360-variant__arrow-icon`);
            return DomElementBuilder.createElement({
                tag: 'li',
                classList: [`${classPrefix}__variant-arrow-wrap`, `${classPrefix}__variant-arrow-wrap--${modifier}`, 'ss360-variant__arrow-wrap', `ss360-variant__arrow-wrap--${modifier}`],
                children: [
                    DomElementBuilder.createElement({
                        tag: 'button',
                        classList: ['ss360-n-button', `${classPrefix}__variant-arrow`, `${classPrefix}__variant-arrow--${modifier}`, 'ss360-variant__arrow', `ss360-variant__arrow--${modifier}`],
                        attrs: {
                            type: 'button',
                            'aria-label': label
                        },
                        children: [icon]
                    })
                ]
            });
        };
        variantUl.appendChild(createVariantWrap('prev', 'Scroll Left'));
        this.variantImages.forEach((entry, idx) => {
            const isActive = activeIdentifier !== undefined ? entry.identifier === activeIdentifier : idx === 0;
            const children = [];
            if (entry.optimizedImage || entry.image) {
                const img = DomElementBuilder.createElement({
                    tag: 'img',
                    classList: [`${classPrefix}__variant-image`, lazyLoadImages ? `${classPrefix}__variant-image--lazy` : undefined, 'ss360-variant__image', lazyLoadImages ? 'ss360-variant__image--lazy' : undefined],
                    attrs: {
                        loading: lazyLoadImages ? 'lazy' : undefined,
                        src: entry.optimizedImage || entry.image,
                        alt: '',
                        'aria-hidden': 'true',
                        role: 'presentation'
                    },
                    data: {
                        fallbackSrc: entry.optimizedImage && entry.optimizedImage !== entry.image ? entry.image : undefined
                    }
                });
                children.push(img);
            }
            else if (entry.value) {
                children.push(DomElementBuilder.createElement({
                    tag: 'span',
                    classList: [`${classPrefix}__variant-value`, 'ss360-variant__value'],
                    textContent: entry.value
                }));
            }
            const activeClass = entry.identifier === suggest.getIdentifier() ? [`${classPrefix}__variant-button--active`, 'ss360-variant__button--active'] : [];
            const btn = DomElementBuilder.createElement({
                tag: 'button',
                classList: [`${classPrefix}__variant-button`, 'ss360-variant__button', 'ss360-n-button', ...activeClass],
                attrs: {
                    type: 'button',
                    title: entry.name,
                    role: 'radio',
                    'aria-checked': `${isActive}`
                },
                data: {
                    productIdentifier: entry.identifier,
                    link: entry.link
                },
                children
            });
            variantUl.appendChild(DomElementBuilder.createElement({
                tag: 'li',
                classList: [`${classPrefix}__variant`, 'ss360-variant', isActive ? 'ss360-variant--active' : undefined, isActive ? `${classPrefix}__variant--active` : undefined],
                children: [btn]
            }));
        });
        variantUl.appendChild(createVariantWrap('next', 'Scroll Right'));
        return variantUl;
    }
}
export default VariantsCarousel;
